import { render, staticRenderFns } from "./BookingNotification.vue?vue&type=template&id=c3d679d0"
import script from "./BookingNotification.vue?vue&type=script&lang=js"
export * from "./BookingNotification.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/vsts/work/1/s/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c3d679d0')) {
      api.createRecord('c3d679d0', component.options)
    } else {
      api.reload('c3d679d0', component.options)
    }
    module.hot.accept("./BookingNotification.vue?vue&type=template&id=c3d679d0", function () {
      api.rerender('c3d679d0', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/modules/fleet/src/components/BookingNotification.vue"
export default component.exports